import React, { Component } from 'react'
import StyleSheet from 'styles'
import FormMixin from 'containers/shared/FormMixin'
import { connect } from 'react-redux'
import { ConditionalRender } from 'components'
import OptionalFiltersList from './OptionalFiltersList'

export class UserSelectFilters extends FormMixin(Component){

  static defaultProps = {
    filters: {},
    prefilters: {},
    onFilterChanged: () => {},
    onRequestClose: () => {},
    scopes: ['investor_account', 'issuer_account'],
    submitRef: () => {}
  }

  componentDidMount(){
    this.props.submitRef(() => this.handleApplyFilter())
  }

  componentWillUnmount(){
    this.props.submitRef(null)
  }

  get formObject(){
    return this.props.filters
  }

  handleFilterChange = () => {
    this.props.onFilterChanged({...this.props.prefilters, ...this.updatedFormObject})
  }

  handleApplyFilter = () => {
    this.handleFilterChange()
    this.props.onRequestClose()
  }

  render = () => {
    const { TextField, DateField } = this
    return (
      <div className={styles.filtersContent}>
        <TextField focusFirst label='Email' attribute='email' className={styles.email} style={{marginTop: '0px'}}/>
        <TextField label='Name' attribute='name'/>
        <DateField label='Created After' attribute='created_at.start' />
        <DateField label='Created Before' attribute='created_at.end' />
        <ConditionalRender component={this.SelectField} requires={!this.props.prefilters.account_type} label='Account Type' attribute='account_type' options={[{label: 'All', value: 'all'}, {label: 'Investor', value: 'investor'}, {label: 'Issuer', value: 'issuer'}]}/>
        <ConditionalRender component={this.SelectField} requires={!this.props.prefilters.access_level} label='User Type' attribute='access_level' options={[{label: 'All', value: ''}, {label: 'Admin', value: 'admin'}, {label: 'Member', value: 'member'}]}/>
        <OptionalFiltersList filters={this.props.filters} scopes={this.props.scopes} context={this} prefilters={this.props.prefilters}/>
      </div>
    )
  }

}

const styles = StyleSheet({
  filtersContent: {
  }
})
export default connect()(UserSelectFilters)